// assets
import './uploadFile.scss';

export function uploadFile() {
  const fileBlock = document.querySelectorAll('[data-file-block]');

  fileBlock.forEach((block) => {
    const realFileBtn = block.querySelector('[data-file]');
    const customBtn = block.querySelector('[data-file-button]');
    const customTxt = block.querySelector('[data-file-text]');

    if (customBtn) {
      customBtn.addEventListener('click', () => {
        realFileBtn.click();
      });

      realFileBtn.addEventListener('change', () => {
        if (realFileBtn.value) {
          customTxt.innerHTML = realFileBtn.value.match(
            /[\/\\]([\w\d\s\.\-\(\)]+)$/,
          )[1];
        } else {
          customTxt.innerHTML = '';
        }
      });
    }
  });
}
